import { createContext } from "react";
import { IBroadcastInfo, IGroupInfo } from "@home-health-notify/domain";

export interface IRightDrawerContext {
  open: boolean;
  setOpen: (open: boolean) => void;
  content?: React.JSX.Element;
  setContent: (content: React.JSX.Element) => void;
  openDrawer: () => void;
  closeDrawer: () => void;
  openAddMembersDrawer: (
    groupInfo: IGroupInfo | IBroadcastInfo,
    showBackButton: boolean,
  ) => void;
  openChatInfoDrawer: (tabValue?: number) => void;
  openChatAssets: () => void;
}

export const RightDrawerContext = createContext<IRightDrawerContext>(
  {} as IRightDrawerContext,
);
